import React, { useState } from 'react';
import './index.scss';

interface FavoriteIconProps {
  onClick: () => void;
  isFavorited: boolean;
}

const FavoriteIcon: React.FunctionComponent<FavoriteIconProps> = ({onClick, isFavorited}) => {
  const [isFavorite, setIsFavorite] = useState(isFavorited)

  const handleFavorite = () => {
    onClick();
    setIsFavorite(!isFavorite)
  }

  return (<div className={`favorite-icon ${isFavorite ? "star-filled" : "star-outline"}`} onClick={handleFavorite} />)

}

export default FavoriteIcon;